module.exports = new __parcel__URL__("not-found.1e5d7fc5.svg").toString();